<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-container-single element-non-bodymatter element-type-also-by element-with-heading" id="also-by">
<div class="heading heading-with-title heading-without-image" id="also-by-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Also by Patricia Dixon</h1>
</div>
</div>
</div>
</div>
<div class="text" id="also-by-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Rosie &amp; Ruby</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Anna</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Tilly</i></p>
</div>
</div>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-square">
<div class="ornamental-break-size-container" style="width: 16.7%">
<img alt="" class="ornamental-break-image" src="images/break-snowflake-screen.png"/>
</div>
</div>
</div>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Over My Shoulder</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>They Don’t Know</i></p>
<p class="alignment-block-content alignment-block-content-center also-by-content"><i>Death’s Dark Veil</i></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// alsobypatriciadixon.vue?61dfc38d